import { withRouter } from 'react-router'

import CalendarSettingsPage from '../page'

import GoogleOAuthConnect from '../GoogleOAuthConnect'
import MicrosoftOAuthConnect from '../MicrosoftOAuthConnect'

import googleGSrc from 'images/onboarding/google-G-logo_L.svg'
import outlookSrc from 'images/logos/office-365.svg'
import 'styles/components/settings/Settings.styl'

const CalendarConnect = ({ googleAuthed, microsoftAuthed, handleSaveRedirect }) => {
  const CalendarLogo = googleAuthed
    ? <img className="connect-calendar-header-logo" src={googleGSrc} alt="Google logo" />
    : <img className="connect-calendar-header-logo" src={outlookSrc} alt="Outlook 365 logo" />
  return (
    <CalendarSettingsPage>
      <div className="subsection">
        <div className="subheader select-calendar">{CalendarLogo}
          <div className="select-calendar-text">{`Connect your ${googleAuthed ? 'Google' : 'Office 365'} calendar`}</div>
        </div>
        <div className="settings-body-copy select-calendar">
          When a new meeting is scheduled with you, we’ll check this calendar for any conflicts and add a new calendar event to it. Don’t see the calendar you want? Make sure it’s not “read-only” and can be modified.
        </div>
          <div className="settings-calendars-connected">
            {googleAuthed && <GoogleOAuthConnect hideIcon={true} buttonLabel="Connect + Finish Setup" onSave={handleSaveRedirect} />}
            {microsoftAuthed && (
              <MicrosoftOAuthConnect hideIcon={true} buttonLabel="Connect + Finish Setup" onSave={handleSaveRedirect} />
            )}
          </div>
        <div className="assistant-footer">
          <div className="subheader select-calendar">When you connect your calendar, you’ll also get your own Drift Assistant</div>
          <p className="settings-body-copy assistant-helper-copy">
            The{' '}
            <a
              href="https://help.drift.com/article/drift-assistant-basics/?v=1536180632162"
              target="_blank"
              rel="noreferrer noopener"
            >
              Drift Assistant
            </a>{' '}
            helps you close more deals with less work. It prepares you for meetings and sends reminders so you never accidentally lose a lead or opportunity again.{' '}
            <a href="https://help.drift.com/article/drift-assistant-basics/" target="_blank" rel="noreferrer noopener">Learn more</a>
          </p>
        </div>
      </div>
    </CalendarSettingsPage>
  )
}

export default withRouter(CalendarConnect)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/CalendarConnect/SelectCalendarComponent.js